import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const InfoDropdownWrapper = styled.div<{ $isOpen: boolean }>`
    width: 100%;
    box-sizing: border-box;
    border-top: ${({ theme }) => '1px solid' + theme.Surface.border};
    border-left: ${({ $isOpen, theme }) => ($isOpen ? '4px solid' + theme.Utility.cta : '4px solid transparent')};
    display: flex;
    flex-direction: row;
    background-color: ${({ $isOpen, theme }) => ($isOpen ? theme.Table.zebraStripe : theme.Surface.primary)};
    padding: 12px;
    transition: all 0.5s;
    max-height: ${({ $isOpen }) => ($isOpen ? '840px' : '76px')};
    overflow-y: hidden;

    ${BaseStyle.Mixins.screenSizes.medium} {
        max-height: ${({ $isOpen }) => ($isOpen ? '500px' : '76px')};
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: ${({ theme }) => theme.Text.primary};
`;

export const ContentHeader = styled.h5`
    margin-top: 16px;
    margin-bottom: 0;
`;

export const ContentBodyWrapper = styled.div`
    text-overflow: ellipsis;
    display: flex;
    width: 100%;
    margin: 24px 0;
    padding-right: 16px;
    ${BaseStyle.Mixins.fontStyles.desktop.body3};
    text-align: left;

    div {
        display: flex;
        flex-direction: column;
    }
    ol {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
        padding-left: 0;
        margin: 16px 0;

        li {
            list-style: inside decimal;
        }
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        padding-right: 60px;
    }
`;
